import templateUrl from 'emun.markdown/markdowns-list.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'

class MarkdownsListController  {
    constructor() {
        const $ctrl = this;
        basicController($ctrl);
        let options = {
            url: 'QueryMarkdowns',
            autoLoad: true,
            append: true
        };
        $ctrl.query = new AutoQuery(options);
        $ctrl.bus = $ctrl.query.bus;
    }

    load() { return this.query.load(); }

    deleteMarkdown(m) {
        let $ctrl = this;
        return $ctrl.modals.confirm("Are you sure?", "Delete Markdown").result.then(function () {
            return $ctrl.bus.send('DeleteMarkdown', m)
            .then(function (response) {
                $ctrl.query.load(true);
            });
        });
    };
}

let MarkdownsList = {
    controller: MarkdownsListController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default MarkdownsList
